module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"action":{"revoke":"Revoke"},"revoked":"Revoked","unavailable":{"text":"Not available yet","title":"Public Access Link is not available yet. It has not finished being processed. Please refresh later and try again."}}}')
  delete Component.options._Ctor
}
